import ActionTypes from '../constants/ActionTypes';

/* Actions */

export const createAlarm = (alarm) => ({
  type: ActionTypes.ALARM_CREATE,
  payload: {
    alarm,
  },
});

export const updateAlarm = (id, data) => ({
  type: ActionTypes.ALARM_UPDATE,
  payload: {
    id,
    data,
  },
});

export const deleteAlarm = (id) => ({
  type: ActionTypes.ALARM_DELETE,
  payload: {
    id,
  },
});

/* Events */

export const createAlarmRequested = (localId, data) => ({
  type: ActionTypes.ALARM_CREATE_REQUESTED,
  payload: {
    localId,
    data,
  },
});

export const createAlarmSucceeded = (localId, alarm) => ({
  type: ActionTypes.ALARM_CREATE_SUCCEEDED,
  payload: {
    localId,
    alarm,
  },
});

export const createAlarmFailed = (localId, error) => ({
  type: ActionTypes.ALARM_CREATE_FAILED,
  payload: {
    localId,
    error,
  },
});

export const createAlarmReceived = (alarm) => ({
  type: ActionTypes.ALARM_CREATE_RECEIVED,
  payload: {
    alarm,
  },
});

export const updateAlarmRequested = (id, data) => ({
  type: ActionTypes.ALARM_UPDATE_REQUESTED,
  payload: {
    id,
    data,
  },
});

export const updateAlarmSucceeded = (alarm) => ({
  type: ActionTypes.ALARM_UPDATE_SUCCEEDED,
  payload: {
    alarm,
  },
});

export const updateAlarmFailed = (id, error) => ({
  type: ActionTypes.ALARM_UPDATE_FAILED,
  payload: {
    id,
    error,
  },
});

export const updateAlarmReceived = (alarm) => ({
  type: ActionTypes.ALARM_UPDATE_RECEIVED,
  payload: {
    alarm,
  },
});

export const deleteAlarmRequested = (id) => ({
  type: ActionTypes.ALARM_DELETE_REQUESTED,
  payload: {
    id,
  },
});

export const deleteAlarmSucceeded = (alarm) => ({
  type: ActionTypes.ALARM_DELETE_SUCCEEDED,
  payload: {
    alarm,
  },
});

export const deleteAlarmFailed = (id, error) => ({
  type: ActionTypes.ALARM_DELETE_FAILED,
  payload: {
    id,
    error,
  },
});

export const deleteAlarmReceived = (alarm) => ({
  type: ActionTypes.ALARM_DELETE_RECEIVED,
  payload: {
    alarm,
  },
});
